import { customerStatusMeta } from "@/components/enquiries/CustomerStatus";

const LABELS = {
  subject: "Subject", message: "Message", service_of_interest: "Service", source_channel: "Channel",
  category_name: "Category", priority: "Priority", assigned_to: "Assigned to", due_at: "Due",
  action_required: "Action required", is_new_enquiry: "New enquiry", next_follow_up_at: "Follow-up", next_action: "Next action",
  customer_status: "Customer status", status: "Status", name: "Name", mobile: "Mobile", email: "Email",
  preferred_channel: "Preferred channel", unknown: "Unknown caller", voicemail_ok: "Voicemail OK",
};
const NESTED = ["contact", "consent", "commercial"];

function fmt(key, v) {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (key === "customer_status") return customerStatusMeta(v)?.label || v;
  if ((key === "due_at" || key === "next_follow_up_at") && !Number.isNaN(Date.parse(v))) {
    return new Date(v).toLocaleString();
  }
  const s = String(v);
  return s.length > 80 ? `${s.slice(0, 80)}…` : s;
}

function changes(before, after) {
  const rows = [];
  for (const key of Object.keys(after || {})) {
    if (!LABELS[key] && !NESTED.includes(key)) continue;
    if (NESTED.includes(key)) {
      const b = (before || {})[key] || {}, a = after[key] || {};
      for (const sub of Object.keys(a)) {
        const from = fmt(sub, b[sub]), to = fmt(sub, a[sub]);
        if (LABELS[sub] && from !== to) {
          rows.push({ key: `${key}.${sub}`, label: LABELS[sub], from, to });
        }
      }
    } else {
      const from = fmt(key, (before || {})[key]), to = fmt(key, after[key]);
      if (from !== to) rows.push({ key, label: LABELS[key], from, to });
    }
  }
  return rows;
}

export function AuditEntry({ entry }) {
  const after = entry.after || {};
  const rows = entry.event === "created" ? [] : changes(entry.before, after);
  const createdStatus = entry.event === "created" && after.customer_status;
  return (
    <li className="text-xs text-zinc-600" data-testid={`enquiry-audit-${entry.id}`}>
      <span className="font-mono-num">{new Date(entry.at).toLocaleString()}</span>
      {" — "}
      <b className="text-zinc-800">{entry.event.replaceAll("_", " ")}</b>
      {" · "}
      {entry.actor_name}
      {(rows.length > 0 || createdStatus || after.reason) && (
        <ul className="ml-4 mt-0.5 space-y-0.5 border-l border-zinc-200 pl-2">
          {createdStatus && (
            <li>Customer status: <b className="text-zinc-800">{fmt("customer_status", after.customer_status)}</b></li>
          )}
          {rows.map((r) => (
            <li key={r.key} data-testid={`audit-change-${entry.id}-${r.key}`}>
              {r.label}: <span className="line-through text-zinc-400">{r.from}</span> → <b className="text-zinc-800">{r.to}</b>
            </li>
          ))}
          {after.reason && (
            <li className="italic text-zinc-500">
              {after.source === "auto" ? "Automatic: " : ""}{after.reason}
              {after.via_enquiry ? ` (via enquiry “${after.via_enquiry}”)` : ""}
            </li>
          )}
        </ul>
      )}
    </li>
  );
}
